import React from 'react';
import '../styles/AboutUs.css';
import Footer from "../components/Footer";
import Header from "../components/Header";
import contributor1 from '../assets/images/owner3.jpg';
import contributor2 from '../assets/images/ahmad.jpg';
import contributor3 from '../assets/images/kabir.jpg';
import contributor4 from '../assets/images/adam.jpg';
import contributor5 from '../assets/images/tola.jpg';
import contributor6 from '../assets/images/dept.webp';

const AboutUs = () => {
  return (
    <div>
     <Header />
    <div className="about-container">
           
      <section className="intro-section">
        <h1>About Cyberkon</h1>
        <p>
         <strong>Cyberkon</strong> is a personal initiative by Abdulakeem Abdulafeez Kolawole, 
         launched in December 2024 and based in Osun State, Nigeria. 
         It reflects my individual effort to bring modern web technologies into the construction industry. 
         Through CyberKon, I aim to create digital tools that improve accuracy, efficiency, and innovation in construction workflows—starting with a material estimation platform.
 </p>

        <p>
          Cyberkon's journey began with our <strong>Construction Estimation Platform</strong>,
which we designed to simplify and automate the estimation of materials like concrete, steel, blocks, mortar,
and formwork. (Note: Roof estimation is coming soon.) While this platform marked our starting point,
it's only the first of many innovative tools we aim to develop in the construction and engineering space.
    </p>
      </section>

      <section className="origin-section">
        <h2>Our Roots</h2>
        <p>
          The vision for Cyberkons began in 2023 during my time as a Building student at the Federal University Birnin Kebbi (FUBK). 
          It was born out of a desire to bridge the gap between traditional construction practices and digital innovation. 
           idea was nurtured within the 2023 graduating set — a few fellow students contributed initial ideas and engineering calculations, 
           while the rest of the class provided valuable feedback by testing the app and helping to ensure its accuracy. 
          Although many have since moved on to careers in various companies, their input played a part in shaping what has now become a focused individual effort.   </p>
      </section>

      <section className="contributors-section">
        <h2>Contributors</h2>
        <div className="contributors">
          <div className="contributor">
            <img src={contributor1} alt="Contributor 1" />
            <p>Abdulakeem Abdulafeez K. - Founder & Full Stack Developer</p>
          </div>
          <div className="contributor">
            <img src={contributor2} alt="Contributor 2" />
            <p>Muhammad Ahmad - Concrete Logic & Estimation</p>
          </div>
          <div className="contributor">
            <img src={contributor3} alt="Contributor 3" />
            <p>Kabeer Idris - Formwork Logic & Calculations</p>
          </div>
          <div className="contributor">
            <img src={contributor4} alt="Contributor 3" />
            <p>Adam Olankunle - Blockwork Calculations</p>
          </div>
          <div className="contributor">
            <img src={contributor5} alt="Contributor 3" />
            <p>Olaniyi Tola - Estimation Logic Calculations</p>
          </div>
        
        </div>
 
      </section>

<section className="contributorMM">
 <div className="contributorM">
            <img src={contributor6} alt="Contributor 3" />
            <p>2023 Final Year Set</p>
          </div>
        </section>
      <section className="contact-section">
        <h2>Get in Touch</h2>
        <p>Want to work with us or learn more?</p>
        <a href="tel:+2347030912661" className="contact-link">Call Us: +234 703 091 2661</a>
      </section>
         <Footer />
    </div>
    </div>
  );
};

export default AboutUs;
